"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMapLocations = void 0;
var React = require("react");
var buttons_1 = require("../../buttons");
var SiteMapLocationForm_1 = require("./forms/SiteMapLocationForm");
var EditMapLocations = function (_a) {
    var site_id = _a.site_id, map_id = _a.map_id, location = _a.location, changeLocation = _a.changeLocation, siteLocationService = _a.siteLocationService, layer_data = _a.layer_data, allow_layer = _a.allow_layer, custom_fields = _a.custom_fields;
    var _b = __read(React.useState(false), 2), isAddingNew = _b[0], setAddingNew = _b[1];
    return layer_data.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row mt-2" },
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () {
                    changeLocation(undefined);
                    setAddingNew(true);
                } }, gettext("Add Location"))),
        (location || isAddingNew) && (React.createElement(SiteMapLocationForm_1.SiteMapLocationForm, { site_id: site_id, map_id: map_id, allow_layer: allow_layer, layer_data: layer_data, custom_fields: custom_fields, location: location, onSave: function (location_data) {
                if (location_data.id > 0)
                    siteLocationService.update(location_data, location_data.id);
                else
                    siteLocationService.create(location_data);
                setAddingNew(false);
            }, onDelete: function (location_data) {
                siteLocationService.remove(location_data.id);
                setAddingNew(false);
            } })))) : (React.createElement("div", null, gettext("No layers defined")));
};
exports.EditMapLocations = EditMapLocations;
